import * as React from 'react';
import { Grid, DialogContent, DialogActions, Button, Dialog, IconButton, DialogTitle } from '@material-ui/core';
import PullFromRepositoryPreviewComponent from './PullFromRepositoryPreviewComponent';
import CloseIcon from '@material-ui/icons/Close';
import { getQuestionsWithAllVersion } from '../../actions/action.module';
import { connect } from 'react-redux';
import { QuestionStatus } from '../../constants/Enum/ModuleEnum';

class QuestionVersionComponent extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            showDialog: false,
            fullWidth: true,
            maxWidth: 'sm',
            question: {},
            questions: [],
            currentPage: 0,
            currentVersion: this.props.question.version,
            isDisableApplyButton: false
        }

        this.handleClose = this.handleClose.bind(this);
        this.onPageClicked = this.onPageClicked.bind(this);

    }

    componentDidMount() {
        const url = window.location.href.split('/');
        const paramId = url[url.lastIndexOf('questions') + 1];
        if (paramId) {
            this.props.getQuestionsWithAllVersion({ moduleId: parseInt(paramId, 10), questionId: this.props.question.question_id });
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps: any) {
        const currentVersion = nextProps.question.version;
        if (nextProps.questionVersions && nextProps.questionVersions.length > 0) {
            const question = nextProps.questionVersions.find((x: { version: any; }) => x.version === currentVersion) ? nextProps.questionVersions.find((x: { version: any; }) => x.version === currentVersion).question : nextProps.questionVersions[0].question;

            this.setState({
                questions: nextProps.questionVersions,
                question,
                currentVersion,
                currentPage: nextProps.questionVersions.findIndex((x: { version: any; }) => x.version === currentVersion),
                isDisableApplyButton: (nextProps.questionVersions.length === 1 || (nextProps.questionVersions.length > 1 && question.version === currentVersion)) ? true : false
            });
        } else {
            const questions = [];
            questions.push(nextProps.question)
            this.setState({
                questions,
                question: nextProps.question,
                currentVersion,
                isDisableApplyButton: true
            });
        }
    }

    handleClose = () => {
        this.props.onDialogClose();
    }

    onPageClicked = (index: number, e: any) => {
        const question = this.state.questions && this.state.questions.length > 0 && this.state.questions[index].question;
        if (question) {
            this.setState({
                question,
                currentVersion: question.version,
                isDisableApplyButton: this.props.question.version === question.version ? true : false
            });
        }
    }

    // select the current selected version question
    handleApplyChanges = () => {
        this.props.onApplyVersionChanges(this.state.question)
        this.handleClose()
    }

    render() {
        return (
            <>
                <Dialog
                    fullWidth={this.state.fullWidth}
                    hideBackdrop={true}
                    maxWidth={this.state.maxWidth}
                    open={this.props.showDialog}
                    aria-labelledby="max-width-dialog-title"
                    className="applicationDialog"
                >
                    <div className="dialogWrapper">
                        <div className="dialogHead">
                            <DialogTitle id="max-width-dialog-title" className="dialogTitle">Question Versions
                                 <IconButton aria-label="Close"
                                    className="closeButton"
                                    onClick={this.handleClose}
                                >
                                    <CloseIcon />
                                </IconButton>
                                <hr className="HZDivider" />
                            </DialogTitle>
                        </div>
                        <div className="dialogContent">
                            <DialogContent>
                                <div className="dialogBox">
                                    <Grid container={true} spacing={24}>
                                        <Grid item={true} xs={12}>
                                            <div className="pagePagination">
                                                {
                                                    this.state.questions && this.state.questions.length > 0 && (
                                                        <ul className="pagination">
                                                            <li className="page-item">Versions: </li>
                                                            {
                                                                this.state.questions.map((question: any, index: any) => {
                                                                    return <li key={index} className="page-item" onClick={this.onPageClicked.bind(this, index)}><a className={question.version === this.state.currentVersion ? 'page-link active' : 'page-link'} href="javascript:void(0)">{index + 1}</a></li>;
                                                                })
                                                            }

                                                        </ul>
                                                    )
                                                }
                                            </div>
                                        </Grid>
                                        <Grid item={true} xs={12}>
                                            {
                                                this.state.question && (
                                                    <PullFromRepositoryPreviewComponent
                                                        question={this.state.question}
                                                    />
                                                )
                                            }
                                        </Grid>
                                    </Grid>
                                </div>
                            </DialogContent>
                        </div>
                        <DialogActions>
                            <Button disabled={this.props.question.status === QuestionStatus.AssignToCreator ? true : this.state.isDisableApplyButton} color="primary" className={(this.state.isDisableApplyButton || this.props.question.status === QuestionStatus.AssignToCreator) ? "buttonDisabled" : "btn-blue-primary"} onClick={this.handleApplyChanges}
                            >
                                Apply Changes &nbsp; >
                                </Button>
                        </DialogActions>
                    </div>
                </Dialog>
            </>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        questionVersions: state.model.questionVersions
    };
};

const mapDispatchToProps = (dispatch: any) => {
    return {
        getQuestionsWithAllVersion: (data: any) => dispatch(getQuestionsWithAllVersion(data))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(QuestionVersionComponent);


// WEBPACK FOOTER //
// ./src/components/questions/QuestionVersionComponent.tsx